<template>
  <a :href="result.url" class="item project" :aria-describedby="result.id">
    <div class="preview" v-if="result.images.length > 0">
      <img :src="result.images[0].url" :alt="result.images[0].altText" />
    </div>
    <div class="text">
      <p class="metaTop" v-if="result.taxonomy[0]">
        {{ result.taxonomy[0].tag.title }}
      </p>
      <h5 :id="result.id" class="title">{{ result.title }}</h5>
      <p class="description">{{ result.description }}</p>
      <div class="icon">
        <svg
          id="blackArrow"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMinYMid"
        >
          <g fill-rule="evenodd">
            <path
              fill="none"
              stroke-width="2"
              d="M309.657 4L309.657 12 301.657 12"
              transform="rotate(45 164.607 -356.425)"
            />
          </g>
        </svg>
      </div>
    </div>
  </a>
</template>
<script lang="ts">
import Vue from "vue";
import { SearchResponseDocument } from "../client/src/models/index";
export default Vue.extend({
  name: "ResultProject",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: () => ({})
    }
  },
});
</script>
